export default class Company {
    constructor() {
        this.id;
        this.name;

    }

    set(setEntity) {
        this.id = setEntity.id;
        this.name = setEntity.name;
        return this;
    }
}
